<template>
	<transition name="slide-fade">
		<div class="loading-data" v-if="loading">
			<i class="el-icon-loading"></i>
			<div>加载中，请稍后···</div>
		</div>
		<div class="due-look" v-if="hide && !loading">
			<div class="look-nav">
				<div class="handle-wrapper" @click="backPath">
					<div class="icon-font">&#xe612;</div>
					<div>返回</div>
				</div>
				<div class="look-nav-center">养护评吸详情</div>
				<div class="handle-wrapper" style="opacity: 0">
					<div class="icon-font">&#xe612;</div>
					<div>返回</div>
				</div>
				<!--点击确认修改评吸意见-->
				<div class="handle-wrapper" @click="UpdatePinxi">
					<div>修改</div>
				</div>
			</div>
			<div class="due-look-content">
				<div class="due-look-top">
					<div class="due-look-top-list">
						<div class="input-contain">
							<div class="input-title">烟叶代码：</div>
							<div class="input-wrapper">
								<input disabled="true" v-model="statusValue.materialCode" placeholder="" />
							</div>
						</div>
						<div class="input-contain">
							<div class="input-title">垛位名称：</div>
							<div class="input-wrapper" style="padding: 0.63vw">
								<div class="popover" style="text-align: left" v-if="statusValue.materialCode.length < 18">
									{{statusValue.siteName}}
								</div>
								<div class="detail-item" style="width: 100%;display: block" v-if="statusValue.materialCode.length >= 18">
									<el-popover placement="top" title="" trigger="hover" :content="statusValue.materialCode">
										<div class="popover" slot="reference">{{statusValue.materialCode}}</div>
									</el-popover>
								</div>
							</div>
						</div>
						<div class="input-contain">
							<div class="input-title" style="padding-left: 0.89vw">养护天数：</div>
							<div class="input-wrapper">
								<input disabled="true" v-model="statusValue.maintainDays" placeholder="" />
							</div>
						</div>
						<div class="input-contain">
							<div class="input-title" style="padding-left: 1.78vw">养护件数：</div>
							<div class="input-suffix-wrapper" style="margin-right: 0">
								<input disabled="true" v-model="maintainCountQu" placeholder="" />
								<div class="input-suffix">（件）</div>
							</div>
						</div>
					</div>
					<div class="due-look-top-list">
						<div class="input-contain">
							<div class="input-title">养 护 人 ：</div>
							<div class="input-wrapper">{{statusValue.principalName}}</div>
						</div>
						<div class="input-contain">
							<div class="input-title" style="padding-left: 1.78vw">评吸意见：</div>
							<div class="input-suffix-wrapper" style="margin-right: 0;width: 56.25vw;">
								<input v-model="content" placeholder="" />
							</div>
						</div>
					</div>
				</div>
				<!-- 评吸评分 -->
				<div class="due-look-bottom">
					<div class="due-look-title">评吸评分</div>
					<div class="detail">
						<div class="detail-box" style="display:flex;flex-direction: column">
							<div class="detail-nav">
								<div class="detail-item" style="width: 15%">样品名</div>
								<div class="detail-item" style="width: 6.3%">风格</div>
								<div class="detail-item" style="width: 6.3%">甜感</div>
								<div class="detail-item" style="width: 6.3%">香气质</div>
								<div class="detail-item" style="width: 6.3%">香气量</div>
								<div class="detail-item" style="width: 6.3%">杂气</div>
								<div class="detail-item" style="width: 6.3%">细腻度</div>
								<div class="detail-item" style="width: 6.3%">浓度</div>
								<div class="detail-item" style="width: 6.3%">劲头</div>
								<div class="detail-item" style="width: 6.3%">刺激性</div>
								<div class="detail-item" style="width: 6.3%">余味</div>
								<div class="detail-item" style="width: 6.3%">评吸人</div>
								<div class="detail-item" style="width: 15.3%">操作</div>
							</div>
							<div class="detail-content" style="flex: 1;padding-bottom: 0;overflow: auto">
								<div class="detail-list-wrapper" v-for="(data,index) in PinxiPinfenList" :key="index">
									<div class="detail-item" style="width: 15%">{{data.sampleName}}</div>
									<div class="detail-item" style="width: 6.3%">{{data.style}}</div>
									<div class="detail-item" style="width: 6.3%">{{data.sweet}}</div>
									<div class="detail-item" style="width: 6.3%">{{data.xqz}}</div>
									<div class="detail-item" style="width: 6.3%">{{data.xql}}</div>
									<div class="detail-item" style="width: 6.3%">{{data.zq}}</div>
									<div class="detail-item" style="width: 6.3%">{{data.xnd}}</div>
									<div class="detail-item" style="width: 6.3%">{{data.nd}}</div>
									<div class="detail-item" style="width: 6.3%">{{data.jt}}</div>
									<div class="detail-item" style="width: 6.3%">{{data.cjx}}</div>
									<div class="detail-item" style="width: 6.3%">{{data.yw}}</div>
									<div class="detail-item" style="width: 6.3%">{{data.pxr}}</div>
									<div class="detail-item" style="width: 15.3%">
										<div class="detail-btn item-look" @click="UpdatePinxiList(index)">修改</div>
										<div class="detail-btn item-delete" style="margin-left: 0.625rem;" @click="deleteList(index)">删除</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="detail-list-wrapper" style="display: flex;margin-top: 0.3125rem;">
					<div class="detail-item" style="width: 15%">
						<div class="input-suffix-wrapper" style="margin-right: 0;padding-right: 0vw;width: 12vw;height: 1.43vw;">
							<input v-model="sampleName" style="text-align: center;" placeholder="" />
						</div>
					</div>
					<div class="detail-item" style="width: 6.3%">
						<div class="input-suffix-wrapper" style="margin-right: 0;padding-right: 0vw;width: 5vw;height: 1.43vw;">
							<input v-model="style" style="text-align: center;" placeholder="" />
						</div>
					</div>
					<div class="detail-item" style="width: 6.3%">
						<div class="input-suffix-wrapper" style="margin-right: 0;padding-right: 0vw;width: 5vw;height: 1.43vw;">
							<input v-model="sweet" style="text-align: center;" placeholder="" />
						</div>
					</div>
					<div class="detail-item" style="width: 6.3%">
						<div class="input-suffix-wrapper" style="margin-right: 0;padding-right: 0vw;width: 5vw;height: 1.43vw;">
							<input v-model="xqz" style="text-align: center;" placeholder="" />
						</div>
					</div>
					<div class="detail-item" style="width: 6.3%">
						<div class="input-suffix-wrapper" style="margin-right: 0;padding-right: 0vw;width: 5vw;height: 1.43vw;">
							<input v-model="xql" style="text-align: center;" placeholder="" />
						</div>
					</div>
					<div class="detail-item" style="width: 6.3%">
						<div class="input-suffix-wrapper" style="margin-right: 0;padding-right: 0vw;width: 5vw;height: 1.43vw;">
							<input v-model="zq" style="text-align: center;" placeholder="" />
						</div>
					</div>
					<div class="detail-item" style="width: 6.3%">
						<div class="input-suffix-wrapper" style="margin-right: 0;padding-right: 0vw;width: 5vw;height: 1.43vw;">
							<input v-model="xnd" style="text-align: center;" placeholder="" />
						</div>
					</div>
					<div class="detail-item" style="width: 6.3%">
						<div class="input-suffix-wrapper" style="margin-right: 0;padding-right: 0vw;width: 5vw;height: 1.43vw;">
							<input v-model="nd" style="text-align: center;" placeholder="" />
						</div>
					</div>
					<div class="detail-item" style="width: 6.3%">
						<div class="input-suffix-wrapper" style="margin-right: 0;padding-right: 0vw;width: 5vw;height: 1.43vw;">
							<input v-model="jt" style="text-align: center;" placeholder="" />
						</div>
					</div>
					<div class="detail-item" style="width: 6.3%">
						<div class="input-suffix-wrapper" style="margin-right: 0;padding-right: 0vw;width: 5vw;height: 1.43vw;">
							<input v-model="cjx" style="text-align: center;" placeholder="" />
						</div>
					</div>
					<div class="detail-item" style="width: 6.3%">
						<div class="input-suffix-wrapper" style="margin-right: 0;padding-right: 0vw;width: 5vw;height: 1.43vw;">
							<input v-model="yw" style="text-align: center;" placeholder="" />
						</div>
					</div>
					<div class="detail-item" style="width: 6.3%">
						<div class="input-suffix-wrapper" style="margin-right: 0;padding-right: 0vw;width: 5vw;height: 1.43vw;">
							<input v-model="pxr" style="text-align: center;" placeholder="" />
						</div>
					</div>

					<div class="handle-wrapper" v-if="donShow==true" @click="savePinxiPinfen" style="width: 5vw;height: 1.43vw;margin-left: 5.25rem;">
						<div>修改</div>
					</div>
					<div class="handle-wrapper" v-else @click="addPinxiPinfen" style="width: 5vw;height: 1.43vw;margin-left: 5.25rem;">
						<div>添加</div>
					</div>
				</div>
				<!-- 养护历史 -->
				<div class="due-look-bottom">
					<div class="due-look-title">养护历史</div>
					<div class="detail">
						<div class="detail-box" style="display:flex;flex-direction: column">
							<div class="detail-nav">
								<div class="detail-item" style="width: 10%">序号</div>
								<div class="detail-item" style="width: 10%">养护计划申请人</div>
								<div class="detail-item" style="width: 20%">申请时间</div>
								<div class="detail-item" style="width: 10%">养护阶段</div>
								<div class="detail-item" style="width: 10%">审核人员</div>
								<div class="detail-item" style="width: 10%">养护时间</div>
								<div class="detail-item" style="width: 5%">审核情况</div>
								<div class="detail-item" style="width: 15%">审核时间</div>
								<div class="detail-item" style="width: 10%">备注</div>
							</div>
							<div class="detail-content" style="flex: 1;padding-bottom: 0;overflow: auto">
								<div class="detail-list-wrapper" v-for="(data,index) in statusValue.planHistoryList" :key="index">
									<div class="detail-item" style="width: 10%">{{index+1}}</div>
									<div class="detail-item" style="width: 10%">{{data.principalName}}</div>
									<div class="detail-item" style="width: 20%">{{getRenderTime(data.createdTime)}}</div>
									<div class="detail-item" style="width: 10%">{{getMaintainStageData(data.maintainStage)}}</div>
									<div class="detail-item" style="width: 10%">{{data.approverName}}</div>
									<div class="detail-item" style="width: 10%">{{data.maintainDays}}</div>
									<div class="detail-item" style="width: 5%" :class="data.approveStatus === 1 ? 'color-green' : data.approveStatus === 2 ? 'color-red' : 'color-set'">{{getApproveStatus(data.approveStatus)}}</div>
									<div class="detail-item" style="width: 15%">{{getRenderTime(data.approverTime)}}</div>
									<div class="detail-item" style="width: 10%;display: block" v-if="data.remark.length < 10">{{data.remark}}</div>
									<div class="detail-item" style="width: 10%;display: block" v-if="data.remark.length >= 10">
										<el-popover placement="top" title="" trigger="hover" :content="data.remark">
											<div class="popover" slot="reference">{{data.remark}}</div>
										</el-popover>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>
<script>
	import {
		querypinxiPlanAndHistorysById,
		updatepinxiPlan
	} from '../../../api/maintain'
	import {
		daysDistance,
		renderTime
	} from '../../../tools/methods'
	export default {
		name: 'DueLook',
		data() {
			return {
				loading: true,
				hide: false,
				statusValue: {},
				// 品吸意见
				content: '',
				invalueid: {
					id: '',
					content: '',
					grade: ''
				},
				// 修改id保存
				indexid: '',
				// 修改和添加按钮的切换
				donShow: false,
				// 评吸评分mobel数据组
				sampleName: '',
				style: '',
				sweet: '',
				xqz: '',
				xql: '',
				zq: '',
				xnd: '',
				nd: '',
				jt: '',
				cjx: '',
				yw: '',
				pxr: '',
				PinxiPinfenList: [

				]
			}
		},
		created() {
			let id = this.$route.query.id
			let _this = this
			setInterval(function() {
				_this.hide = true
			}, 100)
			_this.getpinxiXiangqinglist(id)
		},
		computed: {
			maintainCountQu: function() {
				return Math.floor(this.statusValue.maintainCount / 4)
			}

		},
		methods: {
			getpinxiXiangqinglist: function(id) {
				querypinxiPlanAndHistorysById({
					id: id
				}).then(res => {
					console.log(res.data)
					this.statusValue = res.data
					this.statusValue.warehouseBuildTime = daysDistance(this.statusValue.warehouseBuildTime)
					this.statusValue.maintainStage = this.getMaintainStageData(this.statusValue.maintainStage)
					this.loading = false
					this.content = this.statusValue.content
					if (this.statusValue.gradeList == null) {
						return
					}
					this.PinxiPinfenList = this.statusValue.gradeList
				}).catch(err => {
					console.log(err)
				})
			},
			getRenderTime: function(time) {
				return renderTime(time)
			},
			getApproveStatus: function(approveStatus) {
				if (approveStatus === 0) {
					return '未审核'
				} else if (approveStatus === 1) {
					return '已审核'
				} else if (approveStatus === 2) {
					return '已拒绝'
				}
			},
			getMaintainStageData: function(maintainStage) {
				if (maintainStage === '01') {
					return '自然醇化阶段'
				} else if (maintainStage === '02') {
					return '防霉杀虫阶段'
				} else if (maintainStage === '03') {
					return '气调醇化阶段'
				} else {
					return '气调保质阶段'
				}
			},
			backPath: function() {
				this.$router.go(-1)
			},
			UpdatePinxi: function() {
				this.invalueid.id = this.$route.query.id
				this.invalueid.content = this.content
				this.invalueid.grade = JSON.stringify(this.PinxiPinfenList)
				updatepinxiPlan(this.invalueid).then(res => {
					if (res.code === 200) {
						this.$message({
							message: res.data,
							type: 'warning',
							center: 'true',
							duration: '1000'
						})
						this.getpinxiXiangqinglist(this.invalueid.id)
					} else {
						this.$message({
							message: res.message,
							type: 'warning',
							center: 'true',
							duration: '1000'
						})
					}
				}).catch(err => {
					console.log(err)
				})
			},
			inputdatainInit: function() {
				this.sampleName = ''
				this.style = ''
				this.sweet = ''
				this.xqz = ''
				this.xql = ''
				this.zq = ''
				this.xnd = ''
				this.nd = ''
				this.jt = ''
				this.cjx = ''
				this.yw = ''
				this.pxr = ''
			},
			addPinxiPinfen: function() {
				if (this.sampleName === '' ||
					this.style === '' ||
					this.sweet === '' ||
					this.xqz === '' ||
					this.xql === '' ||
					this.zq === '' ||
					this.xnd === '' ||
					this.nd === '' ||
					this.jt === '' ||
					this.cjx === '' ||
					this.yw === '' ||
					this.pxr === '') {
					this.$message({
						message: '请把信息填写完整再添加',
						type: 'warning',
						center: 'true',
						duration: '1000'
					})
				} else {
					this.PinxiPinfenList.push({
						sampleName: this.sampleName,
						style: this.style,
						sweet: this.sweet,
						xqz: this.xqz,
						xql: this.xql,
						zq: this.zq,
						xnd: this.xnd,
						nd: this.nd,
						jt: this.jt,
						cjx: this.cjx,
						yw: this.yw,
						pxr: this.pxr
					})
					this.inputdatainInit()
					this.UpdatePinxi()
				}
			},
			// 修改列表数据
			UpdatePinxiList: function(index) {
				this.sampleName = this.PinxiPinfenList[index].sampleName
				this.style = this.PinxiPinfenList[index].style
				this.sweet = this.PinxiPinfenList[index].sweet
				this.xqz = this.PinxiPinfenList[index].xqz
				this.xql = this.PinxiPinfenList[index].xql
				this.zq = this.PinxiPinfenList[index].zq
				this.xnd = this.PinxiPinfenList[index].xnd
				this.nd = this.PinxiPinfenList[index].nd
				this.jt = this.PinxiPinfenList[index].jt
				this.cjx = this.PinxiPinfenList[index].cjx
				this.yw = this.PinxiPinfenList[index].yw
				this.pxr = this.PinxiPinfenList[index].pxr
				this.indexid = index + 1
				this.donShow = true
			},
			// 删除列表数据
			deleteList: function(index) {
				if (index === 0) {
					this.PinxiPinfenList.splice(index, index + 1)
				} else {
					this.PinxiPinfenList.splice(index, index)
				}
				this.invalueid.id = this.$route.query.id
				this.invalueid.content = this.content
				this.invalueid.grade = JSON.stringify(this.PinxiPinfenList)
				updatepinxiPlan(this.invalueid).then(res => {
					if (res.code === 200) {
						this.$message({
							message: '删除成功',
							type: 'warning',
							center: 'true',
							duration: '1000'
						})
						this.getpinxiXiangqinglist(this.invalueid.id)
					} else {
						this.$message({
							message: '删除失败',
							type: 'warning',
							center: 'true',
							duration: '1000'
						})
					}
				}).catch(err => {
					console.log(err)
				})
			},
			savePinxiPinfen: function() {
				this.PinxiPinfenList.splice(this.indexid - 1, this.indexid)
				this.PinxiPinfenList.splice(this.indexid - 1, 0, {
					sampleName: this.sampleName,
					style: this.style,
					sweet: this.sweet,
					xqz: this.xqz,
					xql: this.xql,
					zq: this.zq,
					xnd: this.xnd,
					nd: this.nd,
					jt: this.jt,
					cjx: this.cjx,
					yw: this.yw,
					pxr: this.pxr
				})
				this.inputdatainInit()
				this.UpdatePinxi()
			}
		}
	}
</script>

<style scoped>
	@import "Conserve.css";
</style>



// WEBPACK FOOTER //
// src/page/maintain/pinxi/DueLook.vue